// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { EInvalidVotePolicy, EEnableCheckableLists } from "@sequentech/ui-core";
export var ELECTION_CATEGORIES = {
    id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
    tenant_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
    election_event_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
    election_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
    area_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
    description: "With categories",
    public_key: {
        public_key: "ajR/I9RqyOwbpsVRucSNOgXVLCvLpfQxCgPoXGQ2RF4",
        is_demo: true,
    },
    contests: [
        {
            id: "0879c2ff-1212-4c9d-a415-907c47a9e28f",
            tenant_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
            election_event_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
            election_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
            name: "Test question title",
            description: 'This is the description of this question. You can have multiple questions. You can add simple html like <strong>bold</strong> or <a href="https://sequentech.io" rel="nofollow">links to websites</a>.\n\n<br /><br />You need to use two br element for new paragraphs.',
            max_votes: 1,
            min_votes: 1,
            winning_candidates_num: 1,
            voting_type: "first-past-the-post",
            counting_algorithm: "plurality-at-large",
            is_encrypted: true,
            candidates: [
                {
                    id: "780b4eb5-4f83-47b7-a8e0-79343bfa5e43",
                    tenant_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_event_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    contest_id: "0879c2ff-1212-4c9d-a415-907c47a9e28f",
                    name: "Example option 1",
                    description: "This is an option with an simple example description.",
                    candidate_type: "A",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: false,
                        sort_order: 0,
                    },
                },
                {
                    id: "e7b58e4d-7297-4ceb-8f87-f93042f91576",
                    tenant_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_event_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    contest_id: "0879c2ff-1212-4c9d-a415-907c47a9e28f",
                    name: "Example option 2",
                    description: 'An option can contain a description. You can add simple html like <strong>bold</strong> or <a href="https://sequentech.io" rel="nofollow">links to websites</a>. You can also set an image url below, but be sure it&#39;s HTTPS or else it won&#39;t load.\n\n<br /><br />You need to use two br element for new paragraphs.',
                    candidate_type: "A",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: false,
                        sort_order: 1,
                        urls: [
                            {
                                url: "https://sequentech.io",
                                title: "URL",
                                is_image: false,
                            },
                            {
                                url: "/XFQwVFL.jpg",
                                title: "Image URL",
                                is_image: true,
                            },
                        ],
                    },
                },
                {
                    id: "d88d4872-49c3-4f7d-9e24-15a0c82efd01",
                    tenant_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_event_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    contest_id: "0879c2ff-1212-4c9d-a415-907c47a9e28f",
                    name: "Example option 3",
                    candidate_type: "B",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: false,
                        sort_order: 2,
                        urls: [
                            {
                                url: "/XFQwVFL.jpg",
                                title: "Image URL",
                                is_image: true,
                            },
                        ],
                    },
                },
                {
                    id: "d6d097c5-1079-4050-ac96-8f2fe5f0bb37",
                    tenant_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_event_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    contest_id: "0879c2ff-1212-4c9d-a415-907c47a9e28f",
                    name: "A",
                    description: "A Category",
                    candidate_type: "A",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_write_in: false,
                        is_category_list: true,
                        sort_order: 3,
                    },
                },
                {
                    id: "8b7d848a-8d66-47af-8dbd-a811f5ff9582",
                    tenant_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_event_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    contest_id: "0879c2ff-1212-4c9d-a415-907c47a9e28f",
                    name: "B",
                    description: "B Category",
                    candidate_type: "B",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_write_in: false,
                        is_category_list: true,
                        sort_order: 4,
                    },
                },
                {
                    id: "61320aac-0d78-4001-845e-a2f2bd8e800b",
                    tenant_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_event_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    election_id: "67baa473-e29d-49f0-91b5-da4ea6fa3b3f",
                    contest_id: "0879c2ff-1212-4c9d-a415-907c47a9e28f",
                    candidate_type: "B",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_write_in: false,
                        is_category_list: true,
                        sort_order: 5,
                    },
                },
            ],
            presentation: {
                allow_writeins: true,
                base32_writeins: true,
                invalid_vote_policy: EInvalidVotePolicy.ALLOWED,
                shuffle_categories: true,
                shuffle_category_list: [],
                show_points: false,
                enable_checkable_lists: EEnableCheckableLists.CANDIDATES_AND_LISTS,
            },
        },
    ],
};
export var SIMPLE_ELECTION_PLURALITY = {
    id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
    tenant_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
    election_event_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
    election_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
    area_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
    description: "Simple election plurality",
    public_key: {
        public_key: "ajR/I9RqyOwbpsVRucSNOgXVLCvLpfQxCgPoXGQ2RF4",
        is_demo: false,
    },
    contests: [
        {
            id: "1fc963b1-f93b-4151-93d6-bbe0ea5eac46",
            tenant_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
            election_event_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
            election_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
            name: "Simple election plurality",
            description: 'This is the description of this question. You can have multiple questions. You can add simple html like <strong>bold</strong> or <a href="https://sequentech.io" rel="nofollow">links to websites</a>.\n\n<br /><br />You need to use two br element for new paragraphs.',
            max_votes: 1,
            min_votes: 1,
            winning_candidates_num: 1,
            voting_type: "first-past-the-post",
            counting_algorithm: "plurality-at-large",
            is_encrypted: true,
            candidates: [
                {
                    id: "38df9caf-2dc8-472c-87f2-f003241e9510",
                    tenant_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
                    election_event_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
                    election_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
                    contest_id: "1fc963b1-f93b-4151-93d6-bbe0ea5eac46",
                    name: "Example option 1",
                    description: "This is an option with an simple example description.",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: false,
                        sort_order: 0,
                        urls: [
                            {
                                url: "/XFQwVFL.jpg",
                                title: "Image URL",
                                is_image: true,
                            },
                        ],
                    },
                },
                {
                    id: "97ac7d0a-e0f5-4e51-a1ee-6614c0836fec",
                    tenant_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
                    election_event_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
                    election_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
                    contest_id: "1fc963b1-f93b-4151-93d6-bbe0ea5eac46",
                    name: "Example option 2",
                    description: 'An option can contain a description. You can add simple html like <strong>bold</strong> or <a href="https://sequentech.io" rel="nofollow">links to websites</a>. You can also set an image url below, but be sure it&#39;s HTTPS or else it won&#39;t load.\n\n<br /><br />You need to use two br element for new paragraphs.',
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: false,
                        sort_order: 1,
                        urls: [
                            {
                                url: "https://sequentech.io",
                                title: "URL",
                                is_image: false,
                            },
                            {
                                url: "/XFQwVFL.jpg",
                                title: "Image URL",
                                is_image: true,
                            },
                        ],
                    },
                },
                {
                    id: "94c9eafa-ebc6-4594-a176-24788f761ced",
                    tenant_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
                    election_event_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
                    election_id: "60e4ddce-2d5b-4dea-bbae-e81010aa1f0f",
                    contest_id: "1fc963b1-f93b-4151-93d6-bbe0ea5eac46",
                    name: "Example option 3",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: false,
                        sort_order: 2,
                    },
                },
            ],
            presentation: {
                allow_writeins: true,
                base32_writeins: true,
                invalid_vote_policy: EInvalidVotePolicy.ALLOWED,
                shuffle_categories: true,
                shuffle_category_list: [],
                show_points: false,
                enable_checkable_lists: EEnableCheckableLists.CANDIDATES_AND_LISTS,
            },
        },
    ],
};
export var ELECTION_WRITEINS_SIMPLE = {
    id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
    tenant_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
    election_event_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
    election_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
    area_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
    description: "Write-ins simple",
    public_key: {
        public_key: "ajR/I9RqyOwbpsVRucSNOgXVLCvLpfQxCgPoXGQ2RF4",
        is_demo: false,
    },
    contests: [
        {
            id: "1c1500ac-173e-4e78-a59d-91bfa3678c5a",
            tenant_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
            election_event_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
            election_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
            name: "Test question title",
            description: 'This is the description of this question. You can have multiple questions. You can add simple html like <strong>bold</strong> or <a href="https://sequentech.io" rel="nofollow">links to websites</a>.\n\n<br /><br />You need to use two br element for new paragraphs.',
            max_votes: 2,
            min_votes: 1,
            winning_candidates_num: 1,
            voting_type: "first-past-the-post",
            counting_algorithm: "plurality-at-large",
            is_encrypted: true,
            candidates: [
                {
                    id: "f257cd3a-d1cf-4b97-91f8-2dfe156b015c",
                    tenant_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    election_event_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    election_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    contest_id: "1c1500ac-173e-4e78-a59d-91bfa3678c5a",
                    name: "Example option 1",
                    description: "This is an option with an simple example description.",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: false,
                        sort_order: 0,
                    },
                },
                {
                    id: "17325099-f5ab-4c48-a142-6d7ed721e9bb",
                    tenant_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    election_event_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    election_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    contest_id: "1c1500ac-173e-4e78-a59d-91bfa3678c5a",
                    name: "Example option 2",
                    description: 'An option can contain a description. You can add simple html like <strong>bold</strong> or <a href="https://sequentech.io" rel="nofollow">links to websites</a>. You can also set an image url below, but be sure it&#39;s HTTPS or else it won&#39;t load.\n\n<br /><br />You need to use two br element for new paragraphs.',
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: false,
                        sort_order: 1,
                        urls: [
                            {
                                url: "https://sequentech.io",
                                title: "URL",
                                is_image: false,
                            },
                            {
                                url: "/XFQwVFL.jpg",
                                title: "Image URL",
                                is_image: true,
                            },
                        ],
                    },
                },
                {
                    id: "61320aac-0d78-4001-845e-a2f2bd8e800b",
                    tenant_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    election_event_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    election_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    contest_id: "1c1500ac-173e-4e78-a59d-91bfa3678c5a",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: true,
                        sort_order: 2,
                    },
                },
                {
                    id: "e9ad3ed1-4fd5-4498-a0e7-3a3c22ef57d5",
                    tenant_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    election_event_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    election_id: "9570d82a-d92a-44d7-b483-d5a6c8c398a8",
                    contest_id: "1c1500ac-173e-4e78-a59d-91bfa3678c5a",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: true,
                        sort_order: 3,
                    },
                },
            ],
            presentation: {
                allow_writeins: true,
                base32_writeins: true,
                invalid_vote_policy: EInvalidVotePolicy.ALLOWED,
                shuffle_categories: true,
                show_points: false,
                enable_checkable_lists: EEnableCheckableLists.CANDIDATES_AND_LISTS,
            },
        },
    ],
};
export var ELECTION_WITH_INVALID = {
    id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
    tenant_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
    election_event_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
    election_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
    area_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
    description: "With Invalid Vote",
    public_key: {
        public_key: "ajR/I9RqyOwbpsVRucSNOgXVLCvLpfQxCgPoXGQ2RF4",
        is_demo: false,
    },
    contests: [
        {
            id: "87c19855-00de-4093-b155-6fdfa8a24d42",
            tenant_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
            election_event_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
            election_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
            name: "With Invalid Vote",
            description: 'This is the description of the election. You can add simple html like <strong>bold</strong> or <a href="https://sequentech.io" rel="nofollow">links to websites</a>.\n\n<br /><br />You need to use two br element for new paragraphs.',
            max_votes: 1,
            min_votes: 1,
            winning_candidates_num: 1,
            voting_type: "first-past-the-post",
            counting_algorithm: "plurality-at-large",
            is_encrypted: true,
            candidates: [
                {
                    id: "68fc13bd-22a7-4d24-ab59-f43d9c260cf5",
                    tenant_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    election_event_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    election_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    contest_id: "87c19855-00de-4093-b155-6fdfa8a24d42",
                    name: "Example option 1",
                    description: "This is an option with an simple example description.",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: false,
                        sort_order: 0,
                    },
                },
                {
                    id: "08a4b4a5-5933-4843-ba78-6daf2f655e7c",
                    tenant_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    election_event_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    election_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    contest_id: "87c19855-00de-4093-b155-6fdfa8a24d42",
                    name: "Example option 2",
                    description: 'An option can contain a description. You can add simple html like <strong>bold</strong> or <a href="https://sequentech.io" rel="nofollow">links to websites</a>. You can also set an image url below, but be sure it&#39;s HTTPS or else it won&#39;t load.\n\n<br /><br />You need to use two br element for new paragraphs.',
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: false,
                        sort_order: 1,
                        urls: [
                            {
                                url: "https://sequentech.io",
                                title: "URL",
                                is_image: false,
                            },
                            {
                                url: "/XFQwVFL.jpg",
                                title: "Image URL",
                                is_image: true,
                            },
                        ],
                    },
                },
                {
                    id: "d94e8fc4-94c0-4ddc-ab7c-0302c739d7ad",
                    tenant_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    election_event_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    election_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    contest_id: "87c19855-00de-4093-b155-6fdfa8a24d42",
                    presentation: {
                        is_explicit_invalid: false,
                        is_disabled: false,
                        is_category_list: false,
                        is_write_in: true,
                        sort_order: 2,
                    },
                },
                {
                    id: "244327fe-8de2-4701-9f64-f114238ff9ce",
                    tenant_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    election_event_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    election_id: "45b95ddb-e9b7-4a83-ac14-d6fe21574637",
                    contest_id: "87c19855-00de-4093-b155-6fdfa8a24d42",
                    name: "Invalid vote",
                    presentation: {
                        is_explicit_invalid: true,
                        is_category_list: false,
                        invalid_vote_position: "top",
                        is_write_in: false,
                        sort_order: 3,
                    },
                },
            ],
            presentation: {
                allow_writeins: true,
                base32_writeins: true,
                invalid_vote_policy: EInvalidVotePolicy.ALLOWED,
                shuffle_categories: true,
                show_points: false,
                enable_checkable_lists: EEnableCheckableLists.CANDIDATES_AND_LISTS,
            },
        },
    ],
};
export var ELECTIONS_LIST = [
    ELECTION_CATEGORIES,
    SIMPLE_ELECTION_PLURALITY,
    ELECTION_WRITEINS_SIMPLE,
    ELECTION_WITH_INVALID,
];
